<template lang="pug">
    div
        Button(type="primary" @click="isModal = true" icon="md-more" )
        Modal(v-model="isModal" :title="title" width="50" @on-cancel='cancel' footer-hide=true)
            //- p Content of dialog
            //- br
            //- span {{ value }}
            //- br
            //- span {{ data }}
            Form(style="width: 20" :model="value")
                Row(v-for="(item) in data.filter((e)=>e.type!='array' && e.type!='object')" :key="item.id")
                    Col(span="24")
                        FormItem(:label='$t("backendsTitle."+item.id)' :label-width="150")
                            component(:is="item.type" :value="item.value" :disabled="item.disabled" :min="0" :max="item.max" :step="item.step" @[item.fun]="changeData(item,$event)" :multiple="item.multiple" :filterable="item.filterable")
                                Option(v-if="item.type === 'Select' " v-for="(i) in item.options" :value="i.value" :key="i.value") {{ i.label }}

                Row(v-for="(item) in data.filter((e)=>e.type=='object')" :key="item.id")
                    Col(span="24")
                        Tabs(v-model="currentTab" name="modelTabs")
                            template(v-for="(columns) in item.columns" )
                                TabPane(:label='$t("backendsTitle."+columns.id)' :name="columns.id" tab="modelTabs")
                                    template(v-for="(childsColumns) in columns.columns" )
                                        List
                                            ListItem
                                                Col(span="18")
                                                    ListItemMeta(:title='childsColumns.id' :description='$t("backendsTitle."+childsColumns.id)')
                                                Col(span="6")
                                                    component(:is="childsColumns.type" :value="childsColumns.value" :disabled="childsColumns.disabled" :min="0" :max="childsColumns.max" :step="childsColumns.step" @[childsColumns.fun]="changeData(item,$event,columns,childsColumns)")

                Row(v-for="(item) in data.filter((e)=>e.type=='array')" :key="item.id" type="flex" justify="end")
                    Row(type="flex" justify="end")
                        Button(type="primary" style="margin-left: 16px;" @click="addData(item.id)" :disabled="item.disabled") {{'Add'}}
                    Col(span="24")
                        p {{ item.id }}
                        Table.table(
                            ref="xTable"
                            :key="tabKey"
                            :class="tableHeaderStyle"
                            :border="withBorder"
                            style="margin-top: 8px;margin-bottom: 8px;text-overflow: ellipsis"
                            :loading="isTableLoading"
                            :size="tableSize"
                            :columns="item.columns"
                            :data="item.value")
                            template(slot-scope="{row,index}" slot="action")
                                Button(icon="md-trash" shape="circle" :disabled="item.disabled" @click="deleteData(item.id,index)")

            Row(type="flex" justify="end")
                Button(type="primary"  @click="ok"  :disabled="!value['isPurchase']") OK

</template>
<script>
import FormSelect from "./Select/index.js";
export default {
    components: {
        FormSelect,
    },
    props: ["value", "title", "option"],
    data() {
        return {
            isModal: false,
            tabKey: 0,
            isTableLoading: false,
            tableSize: "default",
            data: [],
            rmFiles: [
                "isPurchase",
                "isShown",
                "name",
                "type",
                "formRender",
                "id",
                "value",
                "validityExtend",
                "price",
                "discount",
                "rmFornt",
            ],
            notCanEditFiles: ["validityStart", "validityEnd"],
            changeFilesType: [
                { original: "defaultProvider", Change: "providers" },
                { original: "sslMode", Change: "sslMode" },
            ],
            changeField: [],
            currentTab: "",
            tableKey: {
                domainCNAMEFormat: "format",
                serviceGroupCNAMEFormat: "format",
                groupScope: "groupName",
                providers: "name",
                requestSummary: "value",
                sampling: "value",
                report: "value",
                customizeDashboard: "value",
            },
        };
    },
    computed: {
        tableHeaderStyle() {
            return this.$store.getters.getTableConfig.headerStyle;
        },
        withBorder() {
            return this.$store.getters.getTableConfig.withBorder;
        },
    },
    watch: {},
    methods: {
        async setTables() {
            let objKeys = Object.keys(this.value);
            this.data = objKeys
                .map((e) => {
                    let obj = {};
                    if (this.rmFiles.includes(e)) {
                        return obj;
                    } else if (typeof this.value[e] == "boolean") {
                        obj["type"] = "i-switch";
                        obj["fun"] = "on-change";
                    } else if (typeof this.value[e] == "string") {
                        let changeFile = this.changeFilesType.find((item) => item.original == e);
                        if (changeFile) {
                            obj["type"] = "Select";
                            obj["options"] = this.option[changeFile.Change].name;
                            obj["fun"] = "on-change";
                        } else {
                            obj["type"] = "Input";
                            obj["fun"] = "on-blur";
                        }
                    } else if (typeof this.value[e] == "number") {
                        if (e == "percentage") {
                            obj["step"] = 0.1;
                            obj["max"] = 1;
                        }
                        if (e == "cpuThreshold") {
                            obj["step"] = 1;
                            obj["max"] = 90;
                        }
                        obj["type"] = "InputNumber";
                        obj["fun"] = "on-change";
                    } else if (!Array.prototype.isPrototypeOf(this.value[e])) {
                        obj["type"] = "object";
                        obj["title"] = e;
                        let ObjectKeys = Object.keys(this.value[e]);
                        let columns = [];
                        ObjectKeys.forEach((item) => {
                            let columnsObj = {};
                            if (typeof this.value[e][item] == "boolean") {
                                columnsObj["id"] = item;
                                columnsObj["type"] = "i-switch";
                                columnsObj["fun"] = "on-change";
                                columnsObj["value"] = this.value[e];
                            } else if (typeof this.value[e][item] == "number") {
                                columnsObj["id"] = item;
                                columnsObj["type"] = "InputNumber";
                                columnsObj["fun"] = "on-change";
                                columnsObj["value"] = this.value[e];
                            } else if (!Array.prototype.isPrototypeOf(this.value[e][item])) {
                                let ObjectChildsKeys = Object.keys(this.value[e][item]);
                                let columnsChilds = [];
                                ObjectChildsKeys.forEach((childsItem) => {
                                    let columnsChildsObj = {};
                                    if (typeof this.value[e][item][childsItem] == "boolean") {
                                        columnsChildsObj["id"] = childsItem;
                                        columnsChildsObj["type"] = "i-switch";
                                        columnsChildsObj["fun"] = "on-change";
                                    } else if (typeof this.value[e][item][childsItem] == "number") {
                                        columnsChildsObj["id"] = childsItem;
                                        columnsChildsObj["type"] = "InputNumber";
                                        columnsChildsObj["fun"] = "on-change";
                                    }
                                    columnsChildsObj["value"] = this.value[e][item][childsItem];
                                    columnsChilds.push(columnsChildsObj);
                                });
                                columnsObj["id"] = item;
                                columnsObj["columns"] = columnsChilds;
                            }
                            columns.push(columnsObj);
                        });
                        obj["columns"] = columns;
                    } else if (Array.prototype.isPrototypeOf(this.value[e])) {
                        obj["type"] = "array";

                        if (e == "excludePortsWithinSystemReservedPortRange") {
                            obj["type"] = "Select";
                            let systemReservedPorts = [];
                            for (let i = 5000; i <= 6000; i++) {
                                systemReservedPorts.push({
                                    value: i,
                                    label: i,
                                });
                            }
                            obj["options"] = systemReservedPorts;
                            obj["fun"] = "on-change";
                            obj["multiple"] = true;
                            obj["filterable"] = true;
                        } else if (e == "excludeUnsafePortsWithinHttpsPortRange") {
                            obj["type"] = "Select";
                            obj["options"] = this.option.ports.httpsUnsafePorts;
                            obj["fun"] = "on-change";
                            obj["multiple"] = true;
                            obj["filterable"] = true;
                        } else {
                            let columns = Object.keys(this.option[e]).map((item) => {
                                let columnsObj = {};
                                columnsObj.title = item;
                                columnsObj.key = item;
                                if (typeof this.option[e][item] == "boolean") {
                                    columnsObj.render = (h, params) => {
                                        return renderSwitch(e, h, params, this);
                                    };
                                } else if (typeof this.option[e][item] == "object") {
                                    columnsObj.render = (h, params) => {
                                        return renderSelect(e, h, params, this);
                                    };
                                } else if (typeof this.option[e][item] == "number") {
                                    columnsObj.render = (h, params) => {
                                        return renderNumberInput(e, h, params, this);
                                    };
                                }
                                return columnsObj;
                            });
                            // 新增刪除按鈕
                            columns.push({
                                key: "action",
                                title: "Action",
                                slot: "action",
                                width: 150,
                                align: "center",
                            });
                            obj["columns"] = columns;
                        }
                    }
                    obj["id"] = e;
                    obj["value"] = this.value[e];
                    obj["disabled"] = !this.value["isPurchase"];
                    if (this.notCanEditFiles.includes(e)) {
                        obj["disabled"] = true;
                    }
                    return obj;
                })
                .filter((e) => e.id);
            // this.isTableLoading = false;
        },
        addData(id) {
            let keys = Object.keys(this.option[id]);
            this.data = this.data.map((e) => {
                if (e.id == id) {
                    let pushObj = {};
                    keys.forEach((item) => {
                        pushObj[item] = typeof this.option[id][item] == "object" ? "" : this.option[id][item];
                    });
                    e.value.push(pushObj);
                }
                return e;
            });
        },
        deleteData(id, index) {
            this.$Modal.confirm({
                title: "移除選項",
                content: `您確定要移除表格第${1 + index}列的選項嗎?`,
                okText: "確定",
                onOk: async () => {
                    this.data = this.data.map((e) => {
                        if (e.id == id) {
                            e.value.splice(index, 1);
                            if (!this.changeField.find((item) => item == e.id)) this.changeField.push(e.id);
                        }
                        return e;
                    });
                },
            });
        },
        ok() {
            // 驗證table內容
            this.checkTableData();

            if (!this.isModal) {
                let renObj = {};
                this.data.forEach((e) => {
                    if (this.changeField.includes(e.id)) renObj[e.id] = e.value;
                });
                this.$emit("changeData", this.title, renObj);
            }
        },
        cancel() {
            this.setTables();
        },
        // 檢查table中是否有欄位為空或無效
        hasFieldEmpty(dataColumns, array) {
            if (!Array.isArray(array)) return false;
            // 抓取欄位是空值
            const emptyValue = array.find((valueItem) =>
                dataColumns.find((columnItem) => {
                    // 欄位是dateRangeLimit且value選擇的不是custom不驗證
                    if (columnItem === "dateRangeLimit" && valueItem["value"] !== "99") {
                        return false;
                    }
                    // 欄位是wildcardPrice且name選擇的不是sectigo不驗證
                    if (columnItem === "wildcardPrice" && valueItem["name"] !== "sectigo") {
                        return false;
                    }
                    // 尚未設定欄位，不做判斷
                    if (valueItem[columnItem] === undefined) {
                        return false;
                    }

                    return valueItem[columnItem] === "" || valueItem[columnItem] === null;
                })
            );
            return emptyValue;
        },
        // 檢查table的指定欄位是否有重複
        hasDuplicates(array, key) {
            if (!Array.isArray(array)) return false;
            const values = array.map((item) => item[key]);
            const uniqueValues = new Set(values);
            return uniqueValues.size !== values.length;
        },
        // 驗證各設定table的格式
        checkTableData() {
            // 抓取欄位是array
            const tableData = this.data.filter((e) => Array.isArray(e.value));

            // 抓取欄位 [套用至平台上的所有群]
            const findGlobalScope = this.data.find((e) => e.id == "isGlobalScope");
            const isGlobal = findGlobalScope ? findGlobalScope.value : false;
            // 驗證table是否為空
            const emptyTableData = tableData
                .filter((item) => item.value.length == 0 && !isGlobal)
                .map((item) => item.id);
            if (emptyTableData.length > 0) {
                this.isModal = true;
                return this.$Notice.warning({
                    title: this.$t("global.error"),
                    desc: `data:${emptyTableData.join()} empty`,
                });
            }

            // 檢查table是否重複
            const duplicateTableData = tableData.filter((item) =>
                this.hasDuplicates(item.value, this.tableKey[item.id])
            );
            if (duplicateTableData.length > 0) {
                this.isModal = true;
                return this.$Notice.warning({
                    title: this.$t("global.error"),
                    desc: `field:${duplicateTableData.map((item) => item.id).join()} repeat`,
                });
            }

            // 驗證table欄位是否填寫
            const emptyTableDataField = tableData.filter((item) => {
                // 抓取要驗證的欄位
                const dataColumns = item.columns
                    .filter((e) => !e.slot)
                    .map((e) => {
                        return e.key;
                    });
                if (this.hasFieldEmpty(dataColumns, item.value)) {
                    return true;
                }
            });
            if (emptyTableDataField.length > 0) {
                this.isModal = true;
                return this.$Notice.warning({
                    title: this.$t("global.error"),
                    desc: `field:${emptyTableDataField.map((item) => item.id).join()} empty`,
                });
            }

            this.isModal = false;
        },
        changeData(item, $event, columns, childsColumns) {
            let changeVal = $event;
            if ($event.target) {
                changeVal = $event.target._value;
            }
            this.data = this.data.map((e) => {
                if (e.id == item.id) {
                    if (columns && childsColumns) {
                        e.value[columns.id][childsColumns.id] = changeVal;
                    } else {
                        e.value = changeVal;
                    }
                }
                return e;
            });
            if (!this.changeField.find((e) => e == item.id)) this.changeField.push(item.id);
        },
    },
    mounted() {},
    created() {
        this.setTables();
    },
    destroyed() {},
    beforeDestroy() {},
};

let renderNumberInput = (itemName, h, params, vm) => {
    // default值
    let display = "";
    let max;
    let min = 0;
    let step = 0.1;

    // 抓取設定欄位值
    const findFile = vm.data.find((e) => e.id == itemName);

    // wildcardPrice欄位但name選擇的不是sectigo
    let notSupportWildcardCert = params.column.key == "wildcardPrice" && findFile.value[params.index].name != "sectigo";
    // dateRangeLimit欄位但value欄位選擇的不是99
    const isNotSupportDateRangeLimit =
        params.column.key == "dateRangeLimit" && findFile.value[params.index].value != "99";
    if (isNotSupportDateRangeLimit || notSupportWildcardCert) {
        // 隱藏欄位
        display = "none";
    }

    // dashboard才需要另外處理
    if (params.column.key == "dateRangeLimit") {
        max = vm.option[itemName][params.column.key];
        min = 1;
        step = 1;
    }

    return h("InputNumber", {
        style: {
            display,
        },
        props: {
            // value: vm.value[itemName][params.index][params.column.key],
            value: findFile.value[params.index][params.column.key] || vm.option[itemName][params.column.key],
            min,
            max,
            step,
            disabled: !vm.value["isPurchase"],
        },
        on: {
            "on-change": (event) => {
                // vm.value[itemName][params.index][params.column.key] = event;
                findFile.value[params.index][params.column.key] = event;
                if (!vm.changeField.find((e) => e == itemName)) vm.changeField.push(itemName);
            },
        },
    });
};
let renderSwitch = (itemName, h, params, vm) => {
    let findFile = vm.data.find((e) => e.id == itemName);
    return h("i-switch", {
        props: {
            trueColor: "default",
            // value: vm.value[itemName][params.index][params.column.key],
            value: findFile.value[params.index][params.column.key],
            disabled: !vm.value["isPurchase"],
        },
        on: {
            "on-change": (value) => {
                // vm.value[itemName][params.index][params.column.key] = value;
                findFile.value[params.index][params.column.key] = value;
                if (!vm.changeField.find((e) => e == itemName)) vm.changeField.push(itemName);
            },
        },
    });
};
let renderSelect = (itemName, h, params, vm) => {
    let option =
        itemName == "groupScope"
            ? vm.$store.getters.inGroupNames.filter((e) => e != "all")
            : vm.option[itemName][params.column.key];
    let findFile = vm.data.find((e) => e.id == itemName);
    let parameter = {
        props: {
            // value: vm.value[itemName][params.index][params.column.key],
            value: findFile.value[params.index][params.column.key],
            transfer: true,
            filterable: true,
            multiple: false,
            "allow-create": false,
            disabled: !vm.value["isPurchase"],
        },
        on: {
            "on-change": async (value) => {
                // vm.value[itemName][params.index][params.column.key] = value;
                findFile.value[params.index][params.column.key] = value;
                if (!vm.changeField.find((e) => e == itemName)) vm.changeField.push(itemName);
            },
        },
    };

    return h(
        "Select",
        parameter,
        option.map((item) => {
            return h("Option", {
                props: {
                    value: item.value || item,
                    label: item.label || item,
                },
            });
        })
    );
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/Model.vue